import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { selectCanUseBackendAccessLevels } from '../../../pages/call/selectors';
import { ModalKickConfirmProps } from './types';
import { ModalKickConfirmV1 } from './v1';
import { ModalKickConfirmV2 } from './v2';

export const ModalKickConfirm: FunctionComponent<ModalKickConfirmProps> = (props) => {
    const canUseBackendAccessLevels = useSelector(selectCanUseBackendAccessLevels);
    const Component = canUseBackendAccessLevels ? ModalKickConfirmV2 : ModalKickConfirmV1;

    return <Component {...props} />;
};
